import { calculateBrokerSplit, translatePlanProgress } from 'bundles/backoffice/helpers/plans';

// Rather than implement house split plan calcs, use the plan/progress translated to gross amounts,
// which is mathematically equivalent, then translate some values back. The calculated house split
// can then be stored as the custom plan amount as progress.
export function calculateWithHouseSplitPlan(houseSplitPlan, grossAmount, houseSplitProgress, payables) {
  const calculation = calculateBrokerSplit({
    plan: houseSplitPlan.asGrossPlan,
    originalPlan: houseSplitPlan,
    startingPlanAmount: translatePlanProgress(
      houseSplitProgress,
      houseSplitPlan,
      houseSplitPlan.asGrossPlan,
      translateToFinalTierGrossProgress,
    ),
    grossAmount,
    payables,
  });

  return {
    ...calculation,
    appliedTiers: translateToAppliedHouseSplitTiers(calculation.appliedTiers, houseSplitPlan.tiers),

    // TODO: Wrong for cohort plans, not actually used anywhere - should we just skip this?
    customPlanAmount: grossAmount - calculation.amount,
  };
}

// These are a little nonsensical, as the broker split amount on each tier is not related to the
// tier's from/to values, but it is still better than just returning gross tiers I guess
function translateToAppliedHouseSplitTiers(appliedGrossTiers, houseSplitTiers) {
  return appliedGrossTiers.map((appliedGrossTier) => {
    const houseSplitTier = houseSplitTiers[appliedGrossTier.index];

    const appliedHouseSplitTier = {
      ...appliedGrossTier,
      // Parts of the UI look up tiers by ID, and as gross tiers are not persisted, this matters
      id: houseSplitTier.id,
      from: houseSplitTier.from,
    };

    if (appliedGrossTier.to) {
      appliedHouseSplitTier.to = houseSplitTiers[appliedGrossTier.index].to;
    }

    return appliedHouseSplitTier;
  });
}

function translateToFinalTierGrossProgress(houseSplitFinalTierProgress, houseSplitTier, grossTier) {
  return houseSplitFinalTierProgress / (1 - houseSplitTier.brokerSplit / 100.0) + Math.max(0, grossTier.from - 0.01);
}
